import store from './store/store';

const DEFAULT_LOGO_RELATIVE_PATH = "/static/logo-horiz.png";

export function fieldValues(object) {
	return Object.keys(object).map(key => object[key]);
}

export function range(size, start) {
	let result = [...Array(size).keys()];
	if (start) return result.map(i => i + start);
	return result;
}

export async function viaCep(cep) {
	let res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
	return await res.json();
}

export async function fetchModel(name, fetch, defaultValue) {
	try {
		var { data } = await fetch();
		return data;
	} catch(error) {
		console.error(error);
		store.dispatch("showAlert", { message: `Erro ao buscar ${name}!`, code: 0, style: "danger" });
		return defaultValue || [];
	}
}

export function getLogoUrl(charging) {
		return charging.logoUrl || DEFAULT_LOGO_RELATIVE_PATH;
}



// WEBPACK FOOTER //
// ./src/utils.js